<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import ThreeColumnLayout from "@/components/_common/ThreeColumnLayout.vue";
import GeofenceMap from '@/components/geofence/map/GeofenceMap.vue';
import GeofenceDetailsNavBar from '@/components/geofence/details/GeofenceDetailsNavBar.vue';
import GeofenceCreateView from '@/views/GeofenceCreateView.vue';


import { useSynchronizedSidebars } from "@/composables/useSynchronizedSidebars";
useSynchronizedSidebars();

import {useResetChatOnSidebarClose} from "@/composables/useResetChatOnSidebarClose";
useResetChatOnSidebarClose();

import {useResetChatOnAccountOrUserChange} from "@/composables/useResetChatOnAccountOrUserChange";
useResetChatOnAccountOrUserChange();


import {setTitle} from "@/utils/title";
setTitle('Create Geofence');
</script>


<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <GeofenceDetailsNavBar />
    </template>
    <template #left>
      <GeofenceCreateView />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <GeofenceMap view="create" />
    </template>
  </ThreeColumnLayout>
</template>
